/**
 * Run `task` when the browser is next idle. Uses `requestIdleCallback` where available; falls back to
 * a short `setTimeout` on engines without it (notably Safari — the DOM lib types it as always present,
 * but at runtime it can be absent, hence the runtime feature-detect). MUST be called from inside an
 * effect (never at module scope), so `window` is guaranteed present.
 *
 * Shared by the post-login warm-ups — {@link usePrefetchPrivateRoutes} (route chunks) and
 * {@link usePrefetchPrivateData} (list data) — so both defer to idle the same way and never compete
 * with the app's own post-login work.
 */
export function scheduleIdle(task: () => void): void {
	if (typeof window.requestIdleCallback === "function") {
		window.requestIdleCallback(task);
	} else {
		window.setTimeout(task, 200);
	}
}
